import { useTranslation } from 'react-i18next';
import { format, getYear, parseISO } from 'date-fns';

import type { PeriodFilter } from '@/hooks';

import { DatePicker } from '@/components';
import { MonthPicker } from '@/components/MonthPicker';
import { YearPicker } from '@/components/YearPicker';

import { MONTH_FORMAT } from '@/constants/dates';

import { YEAR_SPAN } from './consts';

type Props = {
  filter: PeriodFilter;
};

export const PeriodPicker = (props: Props) => {
  const { filter } = props;
  const { t } = useTranslation();

  const currentYear = new Date().getFullYear();
  const selectableYears = {
    fromYear: currentYear - YEAR_SPAN,
    toYear: currentYear + 1,
  };
  const anchor = parseISO(filter.period.from);

  if (filter.activePreset === 'day') {
    return (
      <DatePicker
        label={t('Day')}
        value={filter.period.from}
        onChange={(value) => filter.onAnchorChange(parseISO(value))}
        {...selectableYears}
      />
    );
  }

  if (filter.activePreset === 'month') {
    return (
      <MonthPicker
        label={t('Month')}
        value={format(anchor, MONTH_FORMAT)}
        onChange={(value) => filter.onAnchorChange(parseISO(`${value}-01`))}
      />
    );
  }

  if (filter.activePreset === 'year') {
    return (
      <YearPicker
        label={t('Year')}
        value={String(getYear(anchor))}
        onChange={(value) =>
          filter.onAnchorChange(new Date(Number(value), 0, 1))
        }
      />
    );
  }

  return (
    <>
      <DatePicker
        label={t('From')}
        value={filter.period.from}
        onChange={filter.onFromChange}
        {...selectableYears}
      />
      <DatePicker
        label={t('Till')}
        value={filter.period.till}
        onChange={filter.onTillChange}
        {...selectableYears}
      />
    </>
  );
};
